import React, { useState, useEffect, useRef } from "react";
import { Box, Modal } from "@mui/material";
import herImage from "./assets/heroImage.jpg";
import "./Fold1.css";
import CalendarModal from "../../../../../components/CalendarModal/CalendarModal";
const Fold1 = () => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <div className="fold-content">
      <div className="hero-container">
        <div className="hero-left">
          <div className="hero-badge">
            <span className="badge-icon">🚀</span>
            <span>AI-Powered Claim Processing</span>
          </div>
          <h1 className="hero-title">
            <span className="title-line">Automate Claim Processing &</span>
            <span className="title-line">Adjudication with</span>
            <span className="title-line title-accent"> AI Agents</span>
          </h1>
          <p className="hero-subhead">
            Slash processing time from 3-4 days to minutes- automate 70% of
            routine claims, eliminate manual work, and delight policyholders.
          </p>
          <div className="hero-ctas">
            <button className="btn btn-primary">
              <span>Start Free Pilot</span>
              <svg
                className="btn-arrow"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
            <button onClick={handleOpenModal} className="btn btn-secondary">
              <span>Book a Demo</span>
            </button>
          </div>
        </div>
        <div className="hero-right">
          <div className="hero-image-container">
            <div className="floating-elements">
              <div className="floating-card card-1">
                <div className="card-icon">📞</div>
                <div className="card-text">AI Driven</div>
              </div>
              <div className="floating-card card-2">
                <div className="card-icon">💬</div>
                <div className="card-text">High Speed</div>
              </div>
              <div className="floating-card card-3">
                <div className="card-icon">📈</div>
                <div className="card-text">65% Savings</div>
              </div>
            </div>
            <div
              style={{
                border: "15px solid rgb(243, 239, 233)",
                borderRadius: "28px",
                display: "block",
              }}
              className="hero-image-placeholder"
            >
              <img
                src={herImage}
                alt="AI Voice Agent Dashboard"
                className="hero-image"
              />
            </div>
          </div>
        </div>
      </div>
      <CalendarModal open={modalOpen} handleClose={handleCloseModal} />

      <style jsx global>{`
        @media (max-width: 600px) {
          .hide-on-mobile {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

export default Fold1;
